import { ReactNode } from 'react'
import { VideoUploadAttachment } from 'modules/community/types/post-attachment'

export interface VideoGalleryPreviewProps {
  attachment: VideoUploadAttachment
}

const VideoGalleryPreview = ({ attachment }: VideoGalleryPreviewProps): ReactNode => (
  <article
    key={attachment.id}
    className="inline-flex size-full shrink-0 snap-center justify-center px-20 py-10 lg:aspect-video lg:p-40"
  >
    <video controls src={attachment.url} />
  </article>
)

export default VideoGalleryPreview
